import { inject, Injectable } from '@angular/core';
import flagsmith from 'flagsmith';
import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import { LaunchDarklyActions } from '../store/launch-darkly/launch-darkly.actions';

export interface FlagsmithFeature {
	id: number;
	name: string;
	enabled: boolean;
	value: string | null;
}

@Injectable({
	providedIn: 'root'
})
export class FeatureFlaghService {
	private store = inject(Store);
	intializeFlagsmith(user: string) {
		console.log('Initializing Flagsmith...');
		flagsmith.init({
			environmentID: environment.flagsmithEnvironmentId,
			identity: user,
			onChange: () => {
				this.store.dispatch([
					new LaunchDarklyActions.UpdateFlag(flagsmith.getAllFlags())
				]);
			}
		});
	}
}
